import { useGetActivityStatusTreeSuspense } from "@/orval/gen"
import { TreePillsInput } from "../tree/tree-pills-input"
import { useTranslation } from "react-i18next"

interface Props {
  value?: string[] | null | undefined
  onChange: (value: string[]) => void
}

export function ActivityStatusTreeSelect({ value, onChange, ...props }: Props) {
  const { t, i18n } = useTranslation("app_server")
  const { data: activityStatusTree } = useGetActivityStatusTreeSuspense({
    language: i18n.language,
  })

  return (
    <TreePillsInput
      label={t("ActivityStatus")}
      {...props}
      initialCheckedState={value ?? []}
      onCheckedStateChange={onChange}
      tree={activityStatusTree.tree}
    />
  )
}
